module.exports = __webpack_public_path__ + "img/icon-deposit-02.svg";